import hartyAPIClient from "../clients/hartyAPI";
import HomeUseCase from "../home/HomeUseCase";
import ActivityUseCase from "../activity/ActivityUseCase";
import LoginUseCase from "../login/LoginUseCase";
import PartyUseCase from "../party/PartyUseCase";
import AccountUseCase from "../account/AccountUseCase";
import RegisterUseCase from "../register/RegisterUseCase";
import CreateFormUseCase from "../create-form/CreateFormUseCase";

const homeUseCase = new HomeUseCase(hartyAPIClient);
const activityUseCase = new ActivityUseCase(hartyAPIClient);
const loginUseCase = new LoginUseCase(hartyAPIClient);
const registerUseCase = new RegisterUseCase(hartyAPIClient);
const partyUseCase = new PartyUseCase(hartyAPIClient);
const accountUseCase = new AccountUseCase(hartyAPIClient);
const createFormUseCase = new CreateFormUseCase(hartyAPIClient);

export {
  homeUseCase,
  activityUseCase,
  loginUseCase,
  registerUseCase,
  partyUseCase,
  accountUseCase,
  createFormUseCase,
};
